import React from 'react';
import Title from 'components/BoxContainer/components/Title';
import styles from './styles.module.less';

export default function Card({ title = null, children = null, footer = null }) {
  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className="gx-flex-row gx-justify-content-center">
            <div className="gx-flex-column gx-justify-content-center gx-align-items-center">
              <img width={40} height={25} src="/logo_operonda.png" />
              <Title.SubTitle className="gx-mt-2 gx-mt-2" value={title} />
            </div>
          </div>
          <div className="gx-w-100 gx-mt-2">{children}</div>
        </div>
      </div>
      <div className="gx-flex-row gx-justify-content-center gx-align-items-center gx-mt-3">
        <small>Version: {SYSTEM.version}</small>
      </div>
    </div>
  );
}
